import React from "react";
import { FieldLabel } from "./FieldLabel";
import { SelectMenu } from "./SelectMenu";

/* The intake form's select — F-105. */
export const SelectField = ({
  label,
  id,
  value,
  onChange,
  options = [],
  required = false,
  size = "md",
  /* Forwarded to FieldLabel — the edit-profile forms use its sentence-case
     treatment while the intake steps keep the default caption. */
  labelVariant,
  placeholder,
  prefix,
  error,
  className = "",
  ...rest
}) => {
  const normalised = options.map((o) =>
    typeof o === "object" && o !== null ? o : { value: o, label: String(o) }
  );
  const errorId = id ? `${id}-error` : undefined;

  return (
    <div className={className}>
      {label && (
        <FieldLabel htmlFor={id} required={required} variant={labelVariant}>
          {label}
        </FieldLabel>
      )}
      <SelectMenu
        id={id}
        value={value}
        onChange={onChange}
        options={normalised}
        placeholder={placeholder}
        prefix={prefix}
        error={error}
        required={required}
        size={size}
        {...rest}
      />
      {error && (
        <p id={errorId} role="alert" className="mt-1.5 text-[12px] text-[var(--coral-deep)] font-sans">
          {error}
        </p>
      )}
    </div>
  );
};

export default SelectField;
